export default "__VITE_ASSET__Cyz5DdwO__"